var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('horizontal-stepper',{attrs:{"steps":_vm.demoSteps},on:{"completed-step":_vm.completeStep,"active-step":_vm.isStepActive,"stepper-finished":_vm.alert}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }